import React, { useState } from 'react';

const onDrag = setActive => e => {
  e.preventDefault();
  setActive(true);
}

const onDragExit = setActive => e => {
  e.preventDefault();
  setActive(false);
}

const onDropEvent = (setActive, onDrop) => e => {
  setActive(false);
  
  if(onDrop) {
    onDrop(e);
  }
}

const Dropzone = ({ children, containerClass, containerHoverClass, onDrop, onClick }) => {
  const [ active, setActive ] = useState(false);

  let classNames = containerClass || '';

  if (active && containerHoverClass) {
    classNames += ` ${containerHoverClass}`;
  }

  return (
    <div
      className={classNames}
      onClick={onClick}
      onDragOver={onDrag(setActive)}
      onDragExit={onDragExit(setActive)}
      onDragLeave={onDragExit(setActive)}
      onDrop={onDropEvent(setActive, onDrop)}
    >
      {children({ active })}
    </div>
  );
}

export default Dropzone;